import { useState } from "react";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "@mui/styles";
import { NavLink, useLocation } from "react-router-dom";
import NestedList from "./NestedList";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "0 auto",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  linkColor: {
    "&:hover": {
      color: theme.palette.type === "dark" ? "white" : "black",
    },
    color: theme.palette.type === "dark" ? "white" : "black",
  },
  activeClassName: {
    backgroundColor: theme.palette.primary.light,
    color: 'white',
  },
  highlightLink: {
    backgroundColor: "#F2F3F5",
    color: "black",
  },
}));

export default function Link({ link }) {
  const [selected, setSelected] = useState("");
  const classes = useStyles();
  const location = useLocation();

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.root}
    >
      {link.routes.map((route, index) =>
        route.children ? (
          <NestedList key={index} route={route} />
        ) : (
          <NavLink
            key={`${route.label}-${index}`}
            exact={route.exact}
            to={route.link}
            style={{
              display: "flex",
              padding: "8px",
              alignItems: "center",
              borderRadius: "7px",
            }}
            className={({ isActive }) =>
              isActive
                ? classes.activeClassName
                : `${classes.linkColor} ${route.link === "admin/deliveryPlans"
                  ? classes.highlightLink
                  : ""
                }`
            }
            onClick={() => setSelected(route.link)}
          >
            <ListItemIcon>{route.icon}</ListItemIcon>
            <ListItemText primary={route.label} />
          </NavLink>
        )
      )}
    </List>
  );
}
